import { render, staticRenderFns } from "./PdpProductAttributesContainer.vue?vue&type=template&id=bcd0fbc8&"
import script from "./PdpProductAttributesContainer.vue?vue&type=script&lang=js&"
export * from "./PdpProductAttributesContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports